export const PRODUCT_CATEGORY = 'productCategory'

export const DIGITAL_RETURNS_SESSION_ID_KEY = 'digital_returns_session_id'

export const LSL_API_USER_ID = 'ED31BF49-A1FD-4066-AE46-AF89106D1D57'

export const CUSTOMER_SERVICE_RETURNS_LINK = '/customer-service/returns.html'

export const API_WARNING_MESSAGES = {
  ORDER_NOT_SHIPPED: 'ORDER_NOT_SHIPPED',
  ORDER_NOT_DELIVERED: 'ORDER_NOT_DELIVERED',
  INVALID_EMAIL: 'INVALID_EMAIL',
  INVALID_ORDER_ID: 'INVALID_ORDER_ID',
  INVALID_WAREHOUSE: 'INVALID_WAREHOUSE',
  INVALID_PICKUPADDRESS_REGION: 'INVALID_PICKUPADDRESS_REGION',
}

export const OPTIMIZELY_FLAGS = {
  CUSTOMER_CONSENT_FEATURE: 'dr_returns_customer_consent_feature',
  REDIRECT_TO_CARRIER_PORTAL_FEATURE: 'dr_returns_redirect_to_carrier_feature',
  RETURNS_REASONS_FEATURE: 'dr_returns_reasons_feature',
  PICKUP_ADDRESS_FEATURE: 'dr_returns_pickup_address_feature',
  DELIVERY_NOTE_INFO_LOGINPAGE_FEATURE: 'dr_delivery_note_info_on_login_page_feature',
}
